import axios from 'axios';

export const getCustomers = async (page, entire) => {
  const params = new URLSearchParams();
  if (page) params.set('page', page);
  if (entire) params.set('entire', 'true');
  const query = params.toString();
  const url = query ? `/core/task-customers/?${query}` : '/core/task-customers/';
  const response = await axios.get(url);
  return response;
};

export const createCustomer = async (body) => {
  const url = '/core/task-customers/';
  const response = await axios.post(url, body);
  return response;
};

const customersRestrictedPromiseByOrg = new Map();
const customerByIdPromise = new Map();

export const getCustomersByOrganization = async (organizationId) => {
  if (!organizationId) return { data: { results: [] } };
  const params = new URLSearchParams({ organization: organizationId, entire: 'true' });
  const response = await axios.get(`/core/task-customers/?${params}`);
  return response;
};

export const getCustomersRestricted = async (organizationId) => {
  const key = organizationId ?? 'default';
  if (customersRestrictedPromiseByOrg.has(key)) return customersRestrictedPromiseByOrg.get(key);

  const params = new URLSearchParams();
  if (organizationId) params.set('organization', String(organizationId));
  const query = params.toString();
  const url = query
    ? `/core/task-customers/restricted/?${query}`
    : '/core/task-customers/restricted/';

  const request = axios
    .get(url)
    .then((res) => {
      customersRestrictedPromiseByOrg.delete(key);
      return res;
    })
    .catch((err) => {
      customersRestrictedPromiseByOrg.delete(key);
      throw err;
    });

  customersRestrictedPromiseByOrg.set(key, request);
  return request;
};

export const getCustomerById = async (id) => {
  if (!id) return Promise.resolve({ data: null });
  if (customerByIdPromise.has(id)) return customerByIdPromise.get(id);

  const url = `/core/task-customers/${id}/`;
  const request = axios
    .get(url)
    .then((res) => {
      customerByIdPromise.delete(id);
      return res;
    })
    .catch((err) => {
      customerByIdPromise.delete(id);
      throw err;
    });

  customerByIdPromise.set(id, request);
  return request;
};

export const updateCustomer = async (id, body) => {
  const url = `/core/task-customers/${id}/`;
  const response = await axios.patch(url, body);
  return response;
};

export const deleteCustomer = async (id) => {
  const url = `/core/task-customers/${id}/`;
  const response = await axios.delete(url);
  return response;
};

export const getOrganizations = async () => {
  const url = '/core/organizations/';
  const response = await axios.get(url);
  return response;
};
